import React from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import useStyles from './styles'

const defaultSelector = () => {}

const NameSectionPreview = ({ dataSelector = defaultSelector, name }) => {
  const classes = useStyles()
  const data = useSelector(dataSelector)

  const namePreview = data ? data.name : name

  return <p className={classes.namePreview}>{namePreview}</p>
}

NameSectionPreview.propTypes = {
  dataSelector: PropTypes.func,
  name: PropTypes.string
}

export default NameSectionPreview
